import { render } from "./PolicyManage.vue?vue&type=template&id=3379cfc2"
import script from "./PolicyManage.vue?vue&type=script&lang=js"
export * from "./PolicyManage.vue?vue&type=script&lang=js"

import "./PolicyManage.vue?vue&type=style&index=0&id=3379cfc2&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__